import React, { useEffect, useState } from "react";
import {
  Grid,
  Tooltip,
  Button,
  Typography,
  Box,
  Paper,
  Backdrop,
  CircularProgress,
  withStyles,
  InputLabel,
  Chip,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style.js";
import { IoChevronDownSharp } from "react-icons/io5";
import { CloudUpload } from "@material-ui/icons";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import excel_icon from "../../../images/svg/excel-icon.svg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../../../css/view-resume.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { BsFillInfoCircleFill } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const InformationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#c8d8f8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #7da5f6",
  },
  arrow: {
    color: "#7da5f6",
  },
}))(Tooltip);

const LeaveBalanceUpdate = () => {
  const classes = useStyles();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const [empPayslipData, setEmpPayslipData] = useState([]);
  const [userName, setUserName] = useState([]);
  const [leaveBalanceUploadDate, setLeaveBalanceUploadDate] = useState(
    new Date(),
  );
  const [calendarOpen, setCalendarOpen] = useState(false);

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setLeaveBalanceUploadDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    const file = e.target.files[0];

    if (!file) {
      handleNotificationCall("error", "Upload Failed");
      return;
    }
    handleUpload(file);
  };

  const uploadAndConvertXlsx = async (event) => {
    console.log(event);
    try {
      const target = event.target;
      const file = target.files[0];
      setLoader(true);

      if (!file.name.endsWith(".xlsx")) {
        setLoader(false);
        handleNotificationCall(
          "error",
          "Invalid file format. Please select an XLSX file",
        );
        return;
      }

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const records = XLSX.utils.sheet_to_json(sheet);

          console.log("Data Records:", records);
          setEmpPayslipData(records);
        };

        reader.readAsBinaryString(file);
        console.log("Records:", reader.readAsBinaryString(file));
      } else {
        handleNotificationCall("error", "Only choose xlsx format");
        setLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoader(false);
    }
  };

  const handleUpload = async (file) => {
    if (!selectedFile) {
      setUploadStatus("Please select a file to upload.");
      return;
    }

    var fileName = file.name.split(".").pop();

    if (fileName !== "pdf") {
      handleNotificationCall("error", "Invalid File Format");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/uploadPolicyHandBook`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchData();
      }
    } catch (error) {
      setUploadStatus(
        `Upload failed: ${error.response?.data?.message || error.message}`,
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}payslip/payslipUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData
          .filter((item) => item.fullName !== null)
          .map((item) => ({
            name: item.fullName,
            email: item.email,
            cl: 0,
            sl: 0,
            pl: 0,
            permissions: 0,
            date: moment(leaveBalanceUploadDate).format("YYYY-MM-DD"),
          }));
        setUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const exportToExcel = () => {
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(userName);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "data.xlsx");
  };

  const HeaderElements = () => (
    <Box display="flex" alignItems="baseline" gridGap={4}>
      <Chip label="Step 3" />
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "10px" }}
        disabled={empPayslipData.length <= 0}
        onClick={exportToExcel}
      >
        Update Leave File
        {moment(leaveBalanceUploadDate).format("MMM-yyyy")}
      </Button>
      <Typography>Total : {empPayslipData.length}</Typography>
    </Box>
  );

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Leave Balance Update" />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="start"
            width="100%"
            mt={2}
          >
            <Paper
              variant="outlined"
              style={{
                padding: "20px",
                border: "2px dashed #1976d2",
                marginRight: "10px",
              }}
            >
              <Chip label="Step 1" />
              <Box display="flex" justifyContent="start" mt={2} gap={5}>
                <Box display="flex" flexDirection="column">
                  <InputLabel shrink>Select Month</InputLabel>
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    className="example-custom-input"
                    endIcon={<IoChevronDownSharp />}
                    onClick={handlePayslipCalendarOpen}
                  >
                    {moment(leaveBalanceUploadDate).format("MMM-yyyy")}
                  </Button>
                  {calendarOpen && (
                    <Box
                      position="relative"
                      zIndex={111}
                      className="payslip-month-picker-container"
                    >
                      <DatePicker
                        selected={leaveBalanceUploadDate}
                        onChange={handlePayslipMonthChange}
                        renderMonthContent={renderMonthContent}
                        showMonthYearPicker
                        dateFormat="MM/yyyy"
                        wrapperClassName="payslip-month-calender"
                        popperClassName="payslip-month-calender-popper"
                        inline
                      />
                    </Box>
                  )}
                </Box>
              </Box>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={exportToExcel}
              >
                Generate Upload File for{" "}
                {moment(leaveBalanceUploadDate).format("MMM-yyyy")}
              </Button>
            </Paper>
            {uploadStatus && (
              <Typography variant="body2" color="secondary">
                {uploadStatus}
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="100%"
            mt={2}
          >
            <Paper
              variant="outlined"
              style={{
                padding: "20px",
                width: "100%",
                border: "2px dashed #1976d2",
                marginRight: "10px",
              }}
            >
              <Chip label="Step 2" />
              <Box textAlign="center">
                <img
                  src={excel_icon}
                  style={{ width: "50px", height: "50px" }}
                  width="100%"
                  alt="excel-icon"
                />
                <Typography
                  variant="body2"
                  style={{
                    fontStyle: "italic",
                    color: "#758694",
                    margin: "5px 0px",
                  }}
                >
                  (.XLSX Formats Only)
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  style={{ marginTop: "10px" }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={uploadAndConvertXlsx}
                  />
                </Button>
              </Box>
            </Paper>
            {uploadStatus && (
              <Typography variant="body2" color="secondary">
                {uploadStatus}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => (
                <>
                  <HeaderElements />
                </>
              ),
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Name",
              },
              {
                name: "Email",
              },
              {
                name: "CL",
                options: {
                  customHeadLabelRender: (columnMeta) => (
                    <Box display="flex" alignItems="center" gap={5}>
                      CL
                      <InformationTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              color="inherit"
                              style={{ fontSize: "12px" }}
                            >
                              Casual Leave
                            </Typography>
                          </React.Fragment>
                        }
                        placement="bottom"
                      >
                        <span>
                          <BsFillInfoCircleFill size={16} />
                        </span>
                      </InformationTooltip>
                    </Box>
                  ),
                },
              },
              {
                name: "SL",
                options: {
                  customHeadLabelRender: (columnMeta) => (
                    <Box display="flex" alignItems="center" gap={5}>
                      SL
                      <InformationTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              color="inherit"
                              style={{ fontSize: "12px" }}
                            >
                              Sick Leave
                            </Typography>
                          </React.Fragment>
                        }
                        placement="bottom"
                      >
                        <span>
                          <BsFillInfoCircleFill size={16} />
                        </span>
                      </InformationTooltip>
                    </Box>
                  ),
                },
              },
              {
                name: "PL",
                options: {
                  customHeadLabelRender: (columnMeta) => (
                    <Box display="flex" alignItems="center" gap={5}>
                      PL
                      <InformationTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              color="inherit"
                              style={{ fontSize: "12px" }}
                            >
                              Privilege Leave
                            </Typography>
                          </React.Fragment>
                        }
                        placement="bottom"
                      >
                        <span>
                          <BsFillInfoCircleFill size={16} />
                        </span>
                      </InformationTooltip>
                    </Box>
                  ),
                },
              },
              {
                name: "Permission",
              },
              {
                name: "Date",
              },
            ]}
            data={empPayslipData.map((item, index) => {
              return [
                <>{index + 1}</>,
                item.name,
                item.email,
                item.cl,
                item.sl,
                item.pl,
                item.permissions,
                moment(item.date).format("DD-MM-YYYY"),
              ];
            })}
          />
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default LeaveBalanceUpdate;
